/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  AuthState,
  BlogPost,
  BlogPostInput,
  BlogPostList,
  BlogPostUpdate,
  BlogReleaseResolution,
  BlogReleaseReview,
  BlogRevision,
  BlogRevisionRestore,
  BlogRevisionSummary,
  ConflictResponse,
  ForbiddenResponse,
  HealthStatus,
  InvalidResponse,
  LoginParams,
  Logout200,
  NewsletterSubscriptionInput,
  NewsletterSubscriptionResult,
  ResolveBlogRelease200,
  UnauthorizedResponse
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetBlogSitemapUrl = () => {




  return `/api/blog/sitemap.xml`
}

export const getBlogSitemap = async ( options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getGetBlogSitemapUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBlogSitemapQueryKey = () => {
    return [
    `/api/blog/sitemap.xml`
    ] as const;
    }


export const getGetBlogSitemapQueryOptions = <TData = Awaited<ReturnType<typeof getBlogSitemap>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlogSitemap>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlogSitemapQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlogSitemap>>> = ({ signal }) => getBlogSitemap({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlogSitemap>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBlogSitemapQueryResult = NonNullable<Awaited<ReturnType<typeof getBlogSitemap>>>
export type GetBlogSitemapQueryError = ErrorType<unknown>



export function useGetBlogSitemap<TData = Awaited<ReturnType<typeof getBlogSitemap>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlogSitemap>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBlogSitemapQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListBlogReleasesUrl = () => {




  return `/api/admin/blog/releases`
}

export const listBlogReleases = async ( options?: Parameters<typeof customFetch>[1]): Promise<BlogReleaseReview> => {

  return customFetch<BlogReleaseReview>(getListBlogReleasesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBlogReleasesQueryKey = () => {
    return [
    `/api/admin/blog/releases`
    ] as const;
    }


export const getListBlogReleasesQueryOptions = <TData = Awaited<ReturnType<typeof listBlogReleases>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlogReleases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBlogReleasesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBlogReleases>>> = ({ signal }) => listBlogReleases({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBlogReleases>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBlogReleasesQueryResult = NonNullable<Awaited<ReturnType<typeof listBlogReleases>>>
export type ListBlogReleasesQueryError = ErrorType<unknown>



export function useListBlogReleases<TData = Awaited<ReturnType<typeof listBlogReleases>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlogReleases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBlogReleasesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResolveBlogReleaseUrl = (id: string,) => {




  return `/api/admin/blog/releases/${id}/resolve`
}

export const resolveBlogRelease = async (id: string,
    blogReleaseResolution: BlogReleaseResolution, options?: Parameters<typeof customFetch>[1]): Promise<ResolveBlogRelease200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ResolveBlogRelease200>(getResolveBlogReleaseUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(blogReleaseResolution)
  }
);}





export const getResolveBlogReleaseMutationKey = () => ['resolveBlogRelease'] as const;

export const getResolveBlogReleaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveBlogRelease>>, TError,ResolveBlogReleaseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveBlogRelease>>, TError,ResolveBlogReleaseMutationVariables, TContext> => {

const mutationKey = getResolveBlogReleaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveBlogRelease>>, ResolveBlogReleaseMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  resolveBlogRelease(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveBlogReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof resolveBlogRelease>>>
    export type ResolveBlogReleaseMutationBody = BodyType<BlogReleaseResolution>
    export type ResolveBlogReleaseMutationError = ErrorType<unknown>
    export type ResolveBlogReleaseMutationVariables = {id: string;data: BodyType<BlogReleaseResolution>}

    export const useResolveBlogRelease = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveBlogRelease>>, TError,ResolveBlogReleaseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolveBlogRelease>>,
        TError,
        ResolveBlogReleaseMutationVariables,
        TContext
      > => {
      return useMutation(getResolveBlogReleaseMutationOptions(options));
    }

export const getListBlogPostsUrl = () => {




  return `/api/blog/posts`
}

export const listBlogPosts = async ( options?: Parameters<typeof customFetch>[1]): Promise<BlogPostList> => {

  return customFetch<BlogPostList>(getListBlogPostsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBlogPostsQueryKey = () => {
    return [
    `/api/blog/posts`
    ] as const;
    }


export const getListBlogPostsQueryOptions = <TData = Awaited<ReturnType<typeof listBlogPosts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlogPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBlogPostsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBlogPosts>>> = ({ signal }) => listBlogPosts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBlogPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBlogPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listBlogPosts>>>
export type ListBlogPostsQueryError = ErrorType<unknown>



export function useListBlogPosts<TData = Awaited<ReturnType<typeof listBlogPosts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlogPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBlogPostsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAdminBlogPostsUrl = () => {




  return `/api/admin/blog/posts`
}

export const listAdminBlogPosts = async ( options?: Parameters<typeof customFetch>[1]): Promise<BlogPostList> => {

  return customFetch<BlogPostList>(getListAdminBlogPostsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminBlogPostsQueryKey = () => {
    return [
    `/api/admin/blog/posts`
    ] as const;
    }


export const getListAdminBlogPostsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminBlogPosts>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminBlogPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminBlogPostsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminBlogPosts>>> = ({ signal }) => listAdminBlogPosts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminBlogPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminBlogPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminBlogPosts>>>
export type ListAdminBlogPostsQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse>



export function useListAdminBlogPosts<TData = Awaited<ReturnType<typeof listAdminBlogPosts>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminBlogPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminBlogPostsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateBlogPostUrl = () => {




  return `/api/admin/blog/posts`
}

export const createBlogPost = async (blogPostInput: BlogPostInput, options?: Parameters<typeof customFetch>[1]): Promise<BlogPost> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BlogPost>(getCreateBlogPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(blogPostInput)
  }
);}





export const getCreateBlogPostMutationKey = () => ['createBlogPost'] as const;

export const getCreateBlogPostMutationOptions = <TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBlogPost>>, TError,CreateBlogPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBlogPost>>, TError,CreateBlogPostMutationVariables, TContext> => {

const mutationKey = getCreateBlogPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBlogPost>>, CreateBlogPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createBlogPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBlogPostMutationResult = NonNullable<Awaited<ReturnType<typeof createBlogPost>>>
    export type CreateBlogPostMutationBody = BodyType<BlogPostInput>
    export type CreateBlogPostMutationError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>
    export type CreateBlogPostMutationVariables = {data: BodyType<BlogPostInput>}

    export const useCreateBlogPost = <TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBlogPost>>, TError,CreateBlogPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBlogPost>>,
        TError,
        CreateBlogPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateBlogPostMutationOptions(options));
    }

export const getUpdateBlogPostUrl = (id: string,) => {




  return `/api/admin/blog/posts/${id}`
}

export const updateBlogPost = async (id: string,
    blogPostUpdate: BlogPostUpdate, options?: Parameters<typeof customFetch>[1]): Promise<BlogPost> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BlogPost>(getUpdateBlogPostUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(blogPostUpdate)
  }
);}





export const getUpdateBlogPostMutationKey = () => ['updateBlogPost'] as const;

export const getUpdateBlogPostMutationOptions = <TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBlogPost>>, TError,UpdateBlogPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBlogPost>>, TError,UpdateBlogPostMutationVariables, TContext> => {

const mutationKey = getUpdateBlogPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBlogPost>>, UpdateBlogPostMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateBlogPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBlogPostMutationResult = NonNullable<Awaited<ReturnType<typeof updateBlogPost>>>
    export type UpdateBlogPostMutationBody = BodyType<BlogPostUpdate>
    export type UpdateBlogPostMutationError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>
    export type UpdateBlogPostMutationVariables = {id: string;data: BodyType<BlogPostUpdate>}

    export const useUpdateBlogPost = <TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBlogPost>>, TError,UpdateBlogPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBlogPost>>,
        TError,
        UpdateBlogPostMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateBlogPostMutationOptions(options));
    }

export const getListBlogRevisionsUrl = (id: string,) => {




  return `/api/admin/blog/posts/${id}/revisions`
}

export const listBlogRevisions = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<BlogRevisionSummary[]> => {

  return customFetch<BlogRevisionSummary[]>(getListBlogRevisionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBlogRevisionsQueryKey = (id: string,) => {
    return [
    `/api/admin/blog/posts/${id}/revisions`
    ] as const;
    }


export const getListBlogRevisionsQueryOptions = <TData = Awaited<ReturnType<typeof listBlogRevisions>>, TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlogRevisions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBlogRevisionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBlogRevisions>>> = ({ signal }) => listBlogRevisions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBlogRevisions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBlogRevisionsQueryResult = NonNullable<Awaited<ReturnType<typeof listBlogRevisions>>>
export type ListBlogRevisionsQueryError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse>



export function useListBlogRevisions<TData = Awaited<ReturnType<typeof listBlogRevisions>>, TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlogRevisions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBlogRevisionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBlogRevisionUrl = (id: string,
    revision: number,) => {




  return `/api/admin/blog/posts/${id}/revisions/${revision}`
}

export const getBlogRevision = async (id: string,
    revision: number, options?: Parameters<typeof customFetch>[1]): Promise<BlogRevision> => {

  return customFetch<BlogRevision>(getGetBlogRevisionUrl(id,revision),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBlogRevisionQueryKey = (id: string,
    revision: number,) => {
    return [
    `/api/admin/blog/posts/${id}/revisions/${revision}`
    ] as const;
    }


export const getGetBlogRevisionQueryOptions = <TData = Awaited<ReturnType<typeof getBlogRevision>>, TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse>>(id: string,
    revision: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlogRevision>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlogRevisionQueryKey(id,revision);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlogRevision>>> = ({ signal }) => getBlogRevision(id,revision, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && revision !== null && revision !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlogRevision>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBlogRevisionQueryResult = NonNullable<Awaited<ReturnType<typeof getBlogRevision>>>
export type GetBlogRevisionQueryError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse>



export function useGetBlogRevision<TData = Awaited<ReturnType<typeof getBlogRevision>>, TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse>>(
 id: string,
    revision: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlogRevision>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBlogRevisionQueryOptions(id,revision,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRestoreBlogRevisionUrl = (id: string,) => {




  return `/api/admin/blog/posts/${id}/restore`
}

export const restoreBlogRevision = async (id: string,
    blogRevisionRestore: BlogRevisionRestore, options?: Parameters<typeof customFetch>[1]): Promise<BlogPost> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BlogPost>(getRestoreBlogRevisionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(blogRevisionRestore)
  }
);}





export const getRestoreBlogRevisionMutationKey = () => ['restoreBlogRevision'] as const;

export const getRestoreBlogRevisionMutationOptions = <TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreBlogRevision>>, TError,RestoreBlogRevisionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreBlogRevision>>, TError,RestoreBlogRevisionMutationVariables, TContext> => {

const mutationKey = getRestoreBlogRevisionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreBlogRevision>>, RestoreBlogRevisionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  restoreBlogRevision(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreBlogRevisionMutationResult = NonNullable<Awaited<ReturnType<typeof restoreBlogRevision>>>
    export type RestoreBlogRevisionMutationBody = BodyType<BlogRevisionRestore>
    export type RestoreBlogRevisionMutationError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>
    export type RestoreBlogRevisionMutationVariables = {id: string;data: BodyType<BlogRevisionRestore>}

    export const useRestoreBlogRevision = <TError = ErrorType<InvalidResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreBlogRevision>>, TError,RestoreBlogRevisionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreBlogRevision>>,
        TError,
        RestoreBlogRevisionMutationVariables,
        TContext
      > => {
      return useMutation(getRestoreBlogRevisionMutationOptions(options));
    }

export const getGetCurrentAuthUserUrl = () => {




  return `/api/auth/user`
}

export const getCurrentAuthUser = async ( options?: Parameters<typeof customFetch>[1]): Promise<AuthState> => {

  return customFetch<AuthState>(getGetCurrentAuthUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentAuthUserQueryKey = () => {
    return [
    `/api/auth/user`
    ] as const;
    }


export const getGetCurrentAuthUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentAuthUser>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentAuthUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentAuthUser>>> = ({ signal }) => getCurrentAuthUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentAuthUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentAuthUser>>>
export type GetCurrentAuthUserQueryError = ErrorType<unknown>



export function useGetCurrentAuthUser<TData = Awaited<ReturnType<typeof getCurrentAuthUser>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentAuthUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLoginUrl = (params?: LoginParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/login?${stringifiedParams}` : `/api/login`
}

export const login = async (params?: LoginParams, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getLoginUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLoginQueryKey = (params?: LoginParams,) => {
    return [
    `/api/login`, ...(params ? [params] : [])
    ] as const;
    }


export const getLoginQueryOptions = <TData = Awaited<ReturnType<typeof login>>, TError = ErrorType<void>>(params?: LoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof login>>> = ({ signal }) => login(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData> & { queryKey: QueryKey }
}

export type LoginQueryResult = NonNullable<Awaited<ReturnType<typeof login>>>
export type LoginQueryError = ErrorType<void>



export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = ErrorType<void>>(
 params?: LoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getLoginQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAuthCallbackUrl = () => {




  return `/api/callback`
}

export const authCallback = async ( options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getAuthCallbackUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuthCallbackQueryKey = () => {
    return [
    `/api/callback`
    ] as const;
    }


export const getAuthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof authCallback>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authCallback>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthCallbackQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authCallback>>> = ({ signal }) => authCallback({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authCallback>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof authCallback>>>
export type AuthCallbackQueryError = ErrorType<void>



export function useAuthCallback<TData = Awaited<ReturnType<typeof authCallback>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authCallback>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthCallbackQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLogoutUrl = () => {




  return `/api/logout`
}

export const logout = async ( options?: Parameters<typeof customFetch>[1]): Promise<Logout200> => {

  return customFetch<Logout200>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationKey = () => ['logout'] as const;

export const getLogoutMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = getLogoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse>


    export const useLogout = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubscribeNewsletterUrl = () => {




  return `/api/newsletter/subscriptions`
}

/**
 * @summary Save a newsletter subscription with explicit consent
 */
export const subscribeNewsletter = async (newsletterSubscriptionInput: NewsletterSubscriptionInput, options?: Parameters<typeof customFetch>[1]): Promise<NewsletterSubscriptionResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<NewsletterSubscriptionResult>(getSubscribeNewsletterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(newsletterSubscriptionInput)
  }
);}





export const getSubscribeNewsletterMutationKey = () => ['subscribeNewsletter'] as const;

export const getSubscribeNewsletterMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeNewsletter>>, TError,SubscribeNewsletterMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribeNewsletter>>, TError,SubscribeNewsletterMutationVariables, TContext> => {

const mutationKey = getSubscribeNewsletterMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribeNewsletter>>, SubscribeNewsletterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  subscribeNewsletter(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubscribeNewsletterMutationResult = NonNullable<Awaited<ReturnType<typeof subscribeNewsletter>>>
    export type SubscribeNewsletterMutationBody = BodyType<NewsletterSubscriptionInput>
    export type SubscribeNewsletterMutationError = ErrorType<ApiError>
    export type SubscribeNewsletterMutationVariables = {data: BodyType<NewsletterSubscriptionInput>}

    /**
 * @summary Save a newsletter subscription with explicit consent
 */
export const useSubscribeNewsletter = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeNewsletter>>, TError,SubscribeNewsletterMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof subscribeNewsletter>>,
        TError,
        SubscribeNewsletterMutationVariables,
        TContext
      > => {
      return useMutation(getSubscribeNewsletterMutationOptions(options));
    }

